<div class="h-full flex flex-col justify-start items-center overflow-hidden">
    <div *hasBoltOn="[environment.stripe.shaas21products.bo_ai_moderation, environment.stripe.shaas21products.bo_monitoring]" class="w-full">
        <!-- <div class="w-full"> -->
        <div class="sm:flex sm:items-center">
            <div class="sm:flex-auto">
                <h1 class="text-base font-semibold text-primary">Compliance Library</h1>
                <p class="mt-2 text-sm text-secondary">Access compliance guidelines, regulatory requirements, and audit
                    tools for content moderation.</p>
            </div>
            @if (allComplianceDocs() && allComplianceDocs()!.length > 0) {
            <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                <button type="button" (click)="openCreateComplianceModal()"
                    class="block rounded-md bg-primary px-3 py-2 text-center text-sm font-semibold text-white shadow-xs hover:bg-primary/85 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">Add
                    Compliance Document</button>
            </div>
            }
        </div>

        @if (allComplianceDocs() && allComplianceDocs()!.length > 0) {
        <div class="mt-8 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-6 lg:grid-cols-3 xl:gap-x-8">
            @for (doc of allComplianceDocs(); track $index) {
            <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 shadow-sm">
                <div class="flex items-start gap-x-4">
                    <div class="shrink-0">
                        <div class="h-8 w-8 rounded-full bg-green-500 flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-white">
                                <path
                                    d="M10.5 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v6" />
                                <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                                <path d="m14 20 2 2 4-4" />
                            </svg>
                        </div>
                    </div>
                    <div class="flex-1 min-w-0 flex flex-col">
                        <h3 class="text-base font-semibold text-primary">{{ doc.complianceName }}</h3>
                        <p class="mt-1 text-sm text-secondary line-clamp-3">{{ doc.description }}</p>
                        <p class="mt-1 text-xs text-secondary">Last updated: {{ doc.updatedDate ? (doc.updatedDate |
                            date: 'MMM d, y') : (doc.createdDate ? (doc.createdDate | date: 'MMM d, y') : 'N/A') }}</p>
                        <div class="mt-4">
                            <a href="#"
                                class="text-sm font-medium text-accent hover:text-primary/85 dark:hover:text-primary/85 flex items-center gap-x-1">
                                View {{ doc.complianceName }}
                                <span class="inline-block ml-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-4">
                                        <path d="m9 18 6-6-6-6" />
                                    </svg>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            }

        </div>
        } @else if (allComplianceDocs() && allComplianceDocs()!.length === 0) {
        <div class="mt-12 flex flex-col items-center justify-center py-12 px-4">
            <div class="max-w-lg text-center">
                <div
                    class="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 dark:bg-primary/15">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-8 text-accent">
                        <path
                            d="M10.5 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v6" />
                        <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                        <path d="m14 20 2 2 4-4" />
                    </svg>
                </div>
                <h3 class="mt-6 text-lg font-semibold text-primary">No compliance documents yet</h3>
                <p class="mt-3 text-sm leading-6 text-secondary">
                    Add compliance guidelines and regulatory requirements for content moderation.
                    Upload and manage your compliance documents to ensure your content meets industry standards
                    and regulatory requirements.
                </p>
                <div class="mt-8">
                    <button type="button" (click)="openCreateComplianceModal()"
                        class="inline-flex items-center gap-x-2 rounded-md bg-primary dark:bg-primary px-4 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-primary/90 dark:hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path d="M5 12h14" />
                            <path d="M12 5v14" />
                        </svg>
                        Add Your First Compliance Document
                    </button>
                </div>
            </div>
        </div>
        }
        @else {
        <div class="mt-8">
            <p class="text-sm text-primary">Loading compliance documents...</p>
        </div>
        }

    </div>


    <!-- AI Moderation Bolt On NOT Installed -->
    <div *notHasBoltOn="[environment.stripe.shaas21products.bo_ai_moderation, environment.stripe.shaas21products.bo_monitoring]"
        class="h-full w-full overflow-auto">
        <div
            class="mx-auto flex h-full w-full max-w-6xl flex-col items-stretch gap-10 px-4 py-8 lg:flex-row lg:items-center lg:gap-0 lg:px-8 lg:py-10">
        <article class="flex flex-1 flex-col justify-center lg:max-w-xl lg:pr-10">
            <div class="mx-auto w-full max-w-lg text-center lg:mx-0 lg:text-left">
                <div
                    class="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-primary/10 dark:bg-primary/25 mb-6 lg:mx-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-10 text-accent">
                        <path
                            d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" />
                        <path d="m9 9.5 2 2 4-4" />
                    </svg>
                </div>
                <h2 class="text-2xl font-semibold text-primary mb-4">Compliance Documentation</h2>
                <p class="text-base text-secondary leading-relaxed mb-6">
                    Compliance guidelines and regulatory requirements for content moderation. Upload and manage your
                    compliance documents to ensure your content meets industry standards and regulatory requirements.
                </p>
                <div class="space-y-3 text-left max-w-md mx-auto lg:mx-0">
                    <div class="flex items-start gap-3">
                        <div class="shrink-0 mt-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="text-accent">
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                <polyline points="22 4 12 14.01 9 11.01" />
                            </svg>
                        </div>
                        <p class="text-sm text-secondary">
                            <span class="font-semibold text-primary">Brand Safety:</span> Upload detailed documentation
                            with all brand safety guidelines.
                        </p>
                    </div>
                    <div class="flex items-start gap-3">
                        <div class="shrink-0 mt-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="text-accent">
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                <polyline points="22 4 12 14.01 9 11.01" />
                            </svg>
                        </div>
                        <p class="text-sm text-secondary">
                            <span class="font-semibold text-primary">Regulatory Compliance:</span> Ensure that all
                            content complies with all relevant regulations with respect to your brand, social networks
                            and platforms.
                        </p>
                    </div>
                    <div class="flex items-start gap-3">
                        <div class="shrink-0 mt-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="text-accent">
                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                <polyline points="22 4 12 14.01 9 11.01" />
                            </svg>
                        </div>
                        <p class="text-sm text-secondary">
                            <span class="font-semibold text-primary">We'll test it:</span> When creators submit drafts,
                            we'll make sure to flag any content that doesn't comply with your compliance guidelines.
                        </p>
                    </div>
                </div>
            </div>
        </article>

        <div class="hidden lg:block w-px shrink-0 self-stretch bg-zinc-200 dark:bg-zinc-800" aria-hidden="true"></div>

        <!-- Has Subscription - No Bolt On -->
        <article *hasBoltOn="[environment.stripe.shaas21products.sub_essential]"
            class="flex flex-1 flex-col justify-center lg:pl-10">
            <div
                class="mx-auto w-full max-w-md space-y-6 rounded-2xl border border-zinc-200 dark:border-zinc-800 bg-zinc-50/60 dark:bg-zinc-900/40 p-6 lg:p-8">

                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="mx-auto size-10 text-gray-400 dark:text-gray-500 mb-3" aria-hidden="true">
                        <path d="M12 2a10 10 0 0 1 7.38 16.75" />
                        <path d="m16 12-4-4-4 4" />
                        <path d="M12 16V8" />
                        <path d="M2.5 8.875a10 10 0 0 0-.5 3" />
                        <path d="M2.83 16a10 10 0 0 0 2.43 3.4" />
                        <path d="M4.636 5.235a10 10 0 0 1 .891-.857" />
                        <path d="M8.644 21.42a10 10 0 0 0 7.631-.38" />
                    </svg>

                    <h2 class="text-2xl sm:text-3xl font-bold text-zinc-900 dark:text-white mb-2">
                        <span class="text-transparent bg-clip-text bg-linear-to-r from-[#ff80b5] to-[#9089fc]">Upgrade your plan</span>
                    </h2>
                    <p class="text-zinc-600 dark:text-zinc-400 text-sm">
                        Add AI Video Moderation to your plan and keep your content compliant.
                    </p>
                </div>

                <div
                    class="w-full rounded-2xl border border-zinc-200 dark:border-zinc-800 bg-white/80 dark:bg-zinc-900/60 backdrop-blur-sm shadow-sm dark:shadow-none p-5">
                    <div class="flex items-start gap-3 mb-4">
                        <div
                            class="shrink-0 w-10 h-10 rounded-lg bg-zinc-100 dark:bg-zinc-800 flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-6 text-zinc-600 dark:text-white">
                                <path
                                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                            </svg>
                        </div>
                        <div>
                            <h3 class="text-base font-semibold text-zinc-900 dark:text-white">AI Video Moderation</h3>
                            <p class="text-sm text-zinc-600 dark:text-zinc-400 mt-0.5">Unlimited moderations · Use AI to
                                review videos</p>
                        </div>
                    </div>
                    <ul class="space-y-2 text-sm text-zinc-600 dark:text-zinc-300">
                        <li class="flex items-center gap-2">
                            <svg class="size-4 shrink-0 text-accent" viewBox="0 0 20 20" fill="currentColor"
                                aria-hidden="true">
                                <path
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                            Content reviewed against your brief
                        </li>
                        <li class="flex items-center gap-2">
                            <svg class="size-4 shrink-0 text-accent" viewBox="0 0 20 20" fill="currentColor"
                                aria-hidden="true">
                                <path
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                            Suggested fixes &amp; accuracy score
                        </li>
                        <li class="flex items-center gap-2">
                            <svg class="size-4 shrink-0 text-accent" viewBox="0 0 20 20" fill="currentColor"
                                aria-hidden="true">
                                <path
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                            Works with your Compliance Library
                        </li>
                    </ul>
                </div>

                <button type="button" class="inline-flex w-full items-center justify-center gap-x-1.5 flashy-go-button">
                    Upgrade AI Moderation
                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                        class="-mr-0.5 size-5">
                        <path
                            d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                            clip-rule="evenodd" fill-rule="evenodd" />
                    </svg>
                </button>
            </div>
        </article>

        <!-- Has NO Subscription -->
        <article *notHasBoltOn="[environment.stripe.shaas21products.sub_essential]"
            class="flex flex-1 flex-col justify-center lg:pl-10">
            <div
                class="mx-auto w-full max-w-md space-y-6 rounded-2xl border border-zinc-200 dark:border-zinc-800 bg-zinc-50/60 dark:bg-zinc-900/40 p-6 lg:p-8">

                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="mx-auto size-10 text-gray-400 dark:text-gray-500 mb-3" aria-hidden="true">
                        <path d="M12 2a10 10 0 0 1 7.38 16.75" />
                        <path d="m16 12-4-4-4 4" />
                        <path d="M12 16V8" />
                        <path d="M2.5 8.875a10 10 0 0 0-.5 3" />
                        <path d="M2.83 16a10 10 0 0 0 2.43 3.4" />
                        <path d="M4.636 5.235a10 10 0 0 1 .891-.857" />
                        <path d="M8.644 21.42a10 10 0 0 0 7.631-.38" />
                    </svg>

                    <h2 class="text-2xl sm:text-3xl font-bold text-zinc-900 dark:text-white mb-2">
                        <span class="text-transparent bg-clip-text bg-linear-to-r from-[#ff80b5] to-[#9089fc]">Start your
                            free trial</span>
                    </h2>
                    <p class="text-zinc-600 dark:text-zinc-400 text-sm">
                        Get AI Video Moderation and keep your content compliant from day one.
                    </p>
                </div>

                <div
                    class="w-full rounded-2xl border border-zinc-200 dark:border-zinc-800 bg-white/80 dark:bg-zinc-900/60 backdrop-blur-sm shadow-sm dark:shadow-none p-5">
                    <div class="flex items-start gap-3 mb-4">
                        <div
                            class="shrink-0 w-10 h-10 rounded-lg bg-zinc-100 dark:bg-zinc-800 flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-6 text-zinc-600 dark:text-white">
                                <path
                                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                            </svg>
                        </div>
                        <div>
                            <h3 class="text-base font-semibold text-zinc-900 dark:text-white">AI Video Moderation</h3>
                            <p class="text-sm text-zinc-600 dark:text-zinc-400 mt-0.5">Unlimited moderations · Use AI to
                                review videos</p>
                        </div>
                    </div>
                    <ul class="space-y-2 text-sm text-zinc-600 dark:text-zinc-300">
                        <li class="flex items-center gap-2">
                            <svg class="size-4 shrink-0 text-accent" viewBox="0 0 20 20" fill="currentColor"
                                aria-hidden="true">
                                <path
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                            Content reviewed against your brief
                        </li>
                        <li class="flex items-center gap-2">
                            <svg class="size-4 shrink-0 text-accent" viewBox="0 0 20 20" fill="currentColor"
                                aria-hidden="true">
                                <path
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                            Suggested fixes &amp; accuracy score
                        </li>
                        <li class="flex items-center gap-2">
                            <svg class="size-4 shrink-0 text-accent" viewBox="0 0 20 20" fill="currentColor"
                                aria-hidden="true">
                                <path
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                            Works with your Compliance Library
                        </li>
                    </ul>
                </div>

                <button type="button" (click)="openChoosePlan()"
                    class="inline-flex w-full items-center justify-center gap-x-1.5 flashy-go-button">
                    Start Free Trial
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="-mr-0.5 size-5" aria-hidden="true">
                        <path d="M12 2a10 10 0 0 1 7.38 16.75" />
                        <path d="m16 12-4-4-4 4" />
                        <path d="M12 16V8" />
                        <path d="M2.5 8.875a10 10 0 0 0-.5 3" />
                        <path d="M2.83 16a10 10 0 0 0 2.43 3.4" />
                        <path d="M4.636 5.235a10 10 0 0 1 .891-.857" />
                        <path d="M8.644 21.42a10 10 0 0 0 7.631-.38" />
                    </svg>
                </button>
            </div>
        </article>

        </div>
    </div>
    <!-- AI Moderation Bolt On NOT Installed - END -->
</div>

@if (showCreateComplianceModal()) {
<mb-compliance-create (close)="showCreateComplianceModal.set(false)"></mb-compliance-create>
}